import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";

import { SelectComponentsSlice } from "../app/components/SelectComponents/_redux/Slice";
import { Slice as uploadSlice } from "../app/components/upload//_redux/Slice";
import { userProfileCrm } from "../app/modules/UserProfileNew/CrmTab/_redux/Slice";
import { userProfileRewardTransaction } from "../app/modules/UserProfileNew/RewardTab/_redux/Slice";
// import { Slicerewards } from "../app/modules/Reward/_redux/Slice";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";
import { staffUsersSlice } from "../app/modules/Users/StaffUser/_redux/staffUsersSlice";
import { affiliateprogramnewSlice } from "../app/modules/AffiliateProgram/_redux/Slice";
import { apkSlice } from "../app/modules/Master/APKScreenList/_redux/apkSlice";
import { LevelsSlice } from "../app/modules/Master/Levels/_redux/Slice";
import { Slice as levelSlice } from "../app/modules/Levels/_redux/Slice";
import { H5categoriesSlice } from "../app/modules/H5categories/_redux/H5categoriesSlice";
import { H5GamesSlice } from "../app/modules/H5Games/_redux/Slice";
import { Slice as leaderboardSlice } from "../app/modules/LeaderBoard/_redux/Slice";
import { userPlayedGameReportSlice } from "../app/modules/Reports/UsersPlayedGamesReport/_redux/staffUsersSlice";
import { userCoinConsumerReportSlice } from "../app/modules/Reports/UsersCoinConsumerReport/_redux/staffUsersSlice";
import { notificationsSlice } from "../app/modules/Reports/_redux/NotificationSlice";
import { UsersSlice } from "../app/modules/Dashboards/_redux/Slice";
import { HackerSlice } from "../app/modules/Users/Hackers/_redux/HackerSlice";
import { Slice as avatarSlice } from "../app/modules/Avatars/_redux/Slice";
import { Slice as avatarCategorySlice } from "../app/modules/AvatarCategories/_redux/Slice";
import { ComponentsSlice } from "../app/components/_redux/ComponentsSlice";
import { AnalyticsSlice } from "../app/modules/Analytics/_redux/AnalyticsSlice";
import { MarketingReportSlice } from "../app/modules/Reports/MarketingReport/_redux/UsersReportSlice";
import { CoinPackageSlice } from "../app/modules/CoinStores/CoinPackages/_redux/CoinPackageSlice";
import { AddCoinFormSlice } from "../app/modules/CoinStores/AddCoinForm/_redux/AddCoinFormSlice";
import { Slice as coinStoreSlice } from "../app/modules/CoinStores/_redux/Slice";

import { CompanySlice } from "../app/modules/Company/AddCompany/_redux/CompanySlice";
import { TransactionSlice } from "../app/modules/Transactions/_redux/Slice";
import { transactionListFinshell } from "../app/modules/TransactionsFinshell/_redux/Slice";
import { NotificationSlice } from "../app/modules/Notifications/_redux/Slice";
import { Slice as languageSlice } from "../app/modules/Languages/_redux/Slice";
// Reports Starts
import { RetentionReportSlice } from "../app/modules/Reports/RetentionReport/_redux/RetentionReportSlice";
import { GstSlice } from "../app/modules/Reports/GstReport/_redux/GstSlice";
import { DownloadReportSlice } from "../app/modules/Reports/ReportsDownloads/_redux/DownloadReportSlice";
import { LogDownloadReportSlice } from "../app/modules/Reports/LogsDownloads/_redux/DownloadReportSlice";
import { CrmSlice } from "../app/modules/Reports/CrmReport/_redux/CrmSlice";
import { LoginLogsReportSlice } from "../app/modules/Reports/Loginlogsreport/_redux/LoginSlice";
import { BuyCoinsReportSlice } from "../app/modules/Reports/BuyCoinsReport/_redux/BuyCoinsReportSlice";
import { BuyBundlesReportSlice } from "../app/modules/Reports/BuyBundlesReport/_redux/BuyBundlesReportSlice";
import { CashfreeTransactionsReportSlice } from "../app/modules/Reports/CashfreeTransactionsReport/_redux/CashfreeTransactionsReportSlice";
import { UsersLedgerReportSlice } from "../app/modules/Reports/UsersLedgerReport/_redux/UsersLedgerReportSlice";
import { UsersLedgerReportSlice1 } from "../app/modules/Reports/LeadgerSummaryReport/GJ/_redux/UsersLedgerReportSlice";
import { UsersLedgerReportSliced11 } from "../app/modules/Reports/LeadgerSummaryReport/D11/_redux/UsersLedgerReportSlice"; // d11
import { UsersLedgerReportSliceme } from "../app/modules/Reports/LeadgerSummaryReport/ME/_redux/UsersLedgerReportSlice"; // mobily
import { viUsersLedgerReportSlice } from "../app/modules/Reports/LeadgerSummaryReport/VI/_redux/UsersLedgerReportSlice";
import { BusinessDailyReportSlice } from "../app/modules/Reports/BusinessDailyReport/_redux/BusinessDailyReportSlice";
import { RequestLogReportSlice } from "../app/modules/Reports/requestLogReport/_redux/RequestLogReportSlice";
import { AppFlyerSlice } from "../app/modules/Reports/appFlyerReports/_redux/AppFlyerSlice";
import { AddEventsSlice } from "../app/modules/Reports/appFlyerReports/AppEvents/_redux/AddEventsSlice";
import { AppEventsSlice } from "../app/modules/Reports/appEvents/_redux/AddEventsSlice";
import { AllTimeRetentionReportSlice } from "../app/modules/Reports/AllTimeRetentionReport/_redux/AllTimeRetentionReportSlice";
import { ContestsReportSlicee } from "../app/modules/Reports/ContestsReport/_redux/ContestsReportSlice";
import { UserLeaderboardReportSlice } from "../app/modules/Reports/UserLeaderboardReport/_redux/UserLeaderboardReportSlice";
import { UserGameLeaderboardReportSlice } from "../app/modules/Reports/UserGameLeaderboardReport/_redux/UserGameLeaderboardReportSlice";
import { RetentionSlice } from "../app/modules/Reports/Retention/_redux/RetentionSlice";
import { WithdrawalsRequestReportSlice } from "../app/modules/Reports/WithdrawalsRequestReport/_redux/WithdrawalsRequestReportSlice";
import { WalletSummaryReportSlice } from "../app/modules/Reports/WalletSummaryReport/_redux/WalletSummaryReportSlice";
import { UserDailyGameSlice } from "../app/modules/Reports/UserDailyGame/_redux/Slice";
import { Slice as rewardSlice } from "../app/modules/Rewards/_redux/Slice";
import { Slice as dailyLoginRewards } from "../app/modules/RewardDailyLoginReward/_redux/Slice";

import { Slice as rewardSlicee } from "../app/modules/Reward/_redux/Slice";
import { Slice as videoRequestSlice } from "../app/modules/Influencers/_redux/Slice";
import { Slice as collegeSlice } from "../app/modules/Colleges/_redux/Slice";
// Reports Starts
import { Slice as pointCategorySlice } from "../app/modules/PointCategories/_redux/Slice";
// Withdrawals Request Starts
import { WithdrawalsRequestSlice } from "../app/modules/WithdrawalsRequest/_redux/WithdrawalsRequestSlice";
// Withdrawals Request Starts
import { AddContestSlice1 } from "../app/modules/Reports/LeadgerSummaryReport/_redux/LeadgerSummaryReportSlice";
// User Profile New Starts
import { UserProfileNewSlice } from "../app/modules/UserProfileNew/_redux/UserProfileNewSlice";
import { OverviewTabUserProfileNewSlice } from "../app/modules/UserProfileNew/OverviewTab/_redux/OverviewTabUserProfileNewSlice";
import { WalletTabUserProfileNewSlice } from "../app/modules/UserProfileNew/WalletTab/_redux/WalletTabUserProfileNewSlice";
import { GamesTabUserProfileNewSlice } from "../app/modules/UserProfileNew/GamesTab/_redux/GamesTabUserProfileNewSlice";
import { LogsTabUserProfileNewSlice } from "../app/modules/UserProfileNew/LogsTab/_redux/LogsSlice";

// User Profile New Ends

// reward voucher view
import { VoucherNewSlice } from "../app/modules/RewardTransactions/_redux/Slice";
// Contests Starts
import { ContestListSlice } from "../app/modules/Contests/ContestList/_redux/ContestListSlice";
import { ContestCategoriesSlice } from "../app/modules/Contests/ContestCategories/_redux/ContestCategoriesSlice";
import { AddContestCategorySlice } from "../app/modules/Contests/ContestCategories/AddContestCategories/_redux/Slice";
import { ContestUserListSlice } from "../app/modules/Contests/ContestUserList/_redux/ContestUserListSlice";
import { ContestTransactionsSlice } from "../app/modules/Contests/ContestTransactions/_redux/ContestTransactionsSlice";
import { ContestAssignListSlice } from "../app/modules/Contests/ContestAssign/_redux/Slice";
import { AuditContestListSlice } from "../app/modules/Contests/AuditContest/_redux/Slice";
import { ContestAssignShortLinkListSlice } from "../app/modules/Contests/ContestAssignShortLink/_redux/Slice";
import { ContestsReportSlice } from "../app/modules/Contests/ContestsReport/_redux/ContestsReportSlice";
import { ViContestsReportSlice } from "../app/modules/ViContestReport/_redux/ContestsReportSlice";
import { R11ContestsReportSlice } from "../app/modules/R11ContestsReport/_redux/ContestsReportSlice";
import { NewContestsReportSlice } from "../app/modules/Contests/NewContestsReport/_redux/ContestsReportSlice";
// import { ContestsReportSlice } from "../app/modules/Reports/ContestsReport/_redux/ContestsReportSlice";

// Contests Ends

import { Slice as countrySlice } from "../app/modules/Countries/_redux/Slice";
import { FrontendCountrySlice } from "../app/modules/Countries-Frontend/_redux/Slice";
// New Contests Module
import { NewContestTypeSlice } from "../app/modules/NewContest/ContestTypes/_redux/Slice";
import { AddContestTypeSlice } from "../app/modules/NewContest/AddContestTypes/_redux/Slice";
import { NewContestShortLinkSlice } from "../app/modules/NewContest/ContestShortLink/_redux/Slice";
import { NewContestEventListSlice } from "../app/modules/NewContest/ContestEventList/_redux/Slice";
import { AddContestNewAssignSlice } from "../app/modules/NewContest/AddContestShortLink/_redux/Slice";
import { AddContestUserSlice } from "../app/modules/NewContest/ContestUserList/_redux/Slice";
import { AddContestUserFormSlice } from "../app/modules/NewContest/ContestUserList/AddContestUser/_redux/Slice";
import { ContestAssignSlice } from "../app/modules/NewContest/ContestAssign/_redux/Slice";
import { AddContestAssignSlice } from "../app/modules/NewContest/AddContestAssign/_redux/Slice";
import { ContestReAssignSlice } from "../app/modules/NewContest/ContestReAssign/_redux/Slice";
import { AuditContestSlice } from "../app/modules/NewContest/AuditContests/_redux/Slice";
import { AddContestSlice } from "../app/modules/NewContest/AddContest/_redux/Slice";
// import { AddContestSlice1 } from "../app/modules/Reports/LeadgerSummaryReport/_redux/LeadgerSummaryReportSlice";
import { ContestBoardSlice } from "../app/modules/NewContest/ContestBoard/_redux/Slice";
import { NewContestListSlice } from "../app/modules/NewContest/ContestList/_redux/ContestListSlice";
import { NewCasualcontestSlice } from "../app/modules/CasualContest/ContestList/_redux/ContestListSlice";
import { OreedooContestListSlice } from "../app/modules/NewContest/OreedooContestList/_redux/ContestListSlice";
//scrim
import { NewScrimSlice } from "../app/modules/Reports/ScrimReport/_redux/ScrimReportSlice";
import { NewScrimReportSlice } from "../app/modules/Reports/ScrimsReport/_redux/ScrimsReportSlice";
import { NewUserPurchedList } from "../app/modules/Reports/UsersPurched/_redux/Slice";

import { NewPaidList } from "../app/modules/Reports/JoinPaidGame/_redux/Slice";
import { UsersRedeemrewards } from "../app/modules/Reports/UsersRedeemrewards/_redux/Slice";

import { NewScrimTransactionReportSlice } from "../app/modules/Reports/ScrimTransactionReport/_redux/ScrimTransactionReportSlice";
import { ScrimListtSlice } from "../app/modules/Scrims/_redux/Slice";

import { GameScrimSetting } from "../app/modules/Game/GameScrimSetting/_redux/Slice";
import { ScrimsTabUserProfileNewSlice } from "../app/modules/UserProfileNew/ScrimTab/_redux/Slice";
import { NewGamewisereportSlice } from "../app/modules/Reports/GamewiseReport/_redux/Slice";
import { NewCompanyreportSlice } from "../app/modules/Reports/CompanyReport/_redux/Slice";
import { NewAdsreportSlice } from "../app/modules/Reports/AdsReport/_redux/Slice";
import { NewAdspositionSlice } from "../app/modules/Reports/AdsPosition/_redux/Slice";
import { NewAdscompanylistSlice } from "../app/modules/DownloadAdscompanylist/_redux/Slice";
import { NewinitialSettings } from "../app/modules/Subscription/Subscriptionsetting/_redux/Slice";
import { Slice as bannersSlice } from "../app/modules/Banners/_redux/Slice";
//scrim
import { Slice as sponsorSlice } from "../app/modules/Sponsors/_redux/Slice";
import { Slice as sponsorAdSlice } from "../app/modules/Sponsors/Ads/_redux/Slice";
import { Slice as CurrencySlice } from "../app/modules/Currencies/_redux/Slice";
// New Contests Module End

import { TournamentTransactionSlice } from "../app/modules/TournamentTransaction/_redux/Slice";

// Banner's Starts

// Banner's Ends

// Roles Starts
import { NewRoleSlice } from "../app/modules/Roles/NewRole/_redux/NewRoleSlice";
// Roles Ends
import { Slice as pointSlice } from "../app/modules/Points/_redux/Slice";
// Audit Starts
import { AuditReasonsSlice } from "../app/modules/Audits/AuditReasons/_redux/AuditReasonsSlice";
// Audit Ends

// Rewards Starts
import { RewardsTransactionSlice } from "../app/modules/Rewards/RewardsTransaction/_redux/RewardsTransactionSlice";
import { RewardsCategoriesSlice } from "../app/modules/Rewards/RewardsCategories/_redux/RewardsCategoriesSlice";
import { RewardsProductsListSlice } from "../app/modules/Rewards/RewardsProductsList/_redux/RewardsProductsListSlice";
import { RewardsLiveProductsSlice } from "../app/modules/Rewards/RewardsLiveProducts/_redux/RewardsLiveProductsSlice";
// Rewards Ends
import { Slice as blogSlice } from "../app/modules/Blogs/_redux/Slice";
// Youtubes Starts
import { ChannelRequestsSlice } from "../app/modules/Youtubes/ChannelRequests/_redux/ChannelRequestsSlice";
// Youtubes Ends
import { Slice as couponCategorySlice } from "../app/modules/CouponCategories/_redux/Slice";
import { Slice as couponSlice } from "../app/modules/Coupons/_redux/Slice";
// HTML5Games Starts
import { HTML5GamesCategoriesSlice } from "../app/modules/HTML5Games/HTML5GamesCategories/_redux/HTML5GamesCategoriesSlice";
import { HTML5GamesListSlice } from "../app/modules/HTML5Games/HTML5GamesList/_redux/HTML5GamesListSlice";
import { HTML5GamesJoiningListSlice } from "../app/modules/HTML5Games/HTML5GamesJoiningList/_redux/HTML5GamesJoiningListSlice";
import { HTML5GameWiseJoiningListSlice } from "../app/modules/HTML5Games/HTML5GameWiseJoiningList/_redux/HTML5GameWiseJoiningListSlice";
// HTML5Games Ends

// App Flyer Token
import { AppFlyerTokenSlice } from "../app/modules/AppFlyerTokens/AppFlyerTokenList/_redux/AppFlyerTokenSlice";
import { AddAppFlyerTokenSlice } from "../app/modules/AppFlyerTokens/AddAppFlyerTokenList/_redux/AddAppFlyerTokenSlice";
// App Flyer Token Ends

// Game
import { GameListSlice } from "../app/modules/Game/GameList/_redux/GameListSlice";
import { AddGameSlice } from "../app/modules/Game/AddGame/_redux/AddGameSlice";
// Game Ends

//External Game List
import { ExternalGameListSlice } from "../app/modules/ExternalPlatform/GameList/_redux/ExternalGameListSlice";
import { AddExternalGameSlice } from "../app/modules/ExternalPlatform/AddGame/_redux/AddExternalGameSlice";

// Game Type
import { GameTypeListSlice } from "../app/modules/GameType/_redux/Slice";
import { AddGameTypeSlice } from "../app/modules/GameType/AddGameType/_redux/Slice";
// Game Type Ends

// Game Setting Type
import { GameSettings } from "../app/modules/Game/GameSetting/_redux/Slice";
// Game Setting Ends

import { Slice } from "../app/modules/Youtubes/SearchList/_redux/youtubeSlice";
import { Slice as reportsSlice } from "../app/modules/Reports/_redux/Slice";
import { ClashRoyaleSlice } from "../app/modules/ClashRoyale/_redux/Slices";
import { AddCompanyFormSlice } from "../app/modules/Company/AddCompanyForm/_redux/AddCompanyFormSlice";

//FAQ
import { FAQSlice } from "../app/modules/VICMS/_redux/FAQSlice";

//timeslot
import { AddTimeSlotSlice } from "../app/modules/TimeSlot/TimeSlotForm/_redux/Slice";
import { CustomerCareSlice } from "../app/modules/CustomerCare/_redux/Slice";
import { TimeSlotSlice } from "../app/modules/TimeSlot/TimeSlotList/_redux/Slice";
import { BannerLogSlice } from "../app/modules/GamerjiBanneradslogPage/_redux/Slice";
// Vi banner
// import { BannerSlice as viBannerSlice } from "../app/modules/CompanyCms/vi/banner/_redux/Slice";
import { Slice as viBanners } from "../app/modules/CompanyCms/vi/Banners/_redux/Slice";
import { Slice as gjBanners } from "../app/modules/CompanyCms/Gamerji/Banners/_redux/Slice";
import { Slice as gpBanners } from "../app/modules/CompanyCms/goPlay/Banners/_redux/Slice";
import { Slice as amBanners } from "../app/modules/CompanyCms/ampere/Banners/_redux/Slice";
import { Slice as viPages } from "../app/modules/CompanyCms/vi/Pages/_redux/Slice";
import { Slice as glancePages } from "../app/modules/CompanyCms/glance/Pages/_redux/Slice";
import { FAQSlice as FaqByGameSlice } from "../app/modules/CompanyCms/vi/VIFAQByGame/_redux/FAQSlice";
import { Slice as popupNotificationsSlice } from "../app/modules/PopupNotification/_redux/Slice";

import { Slice as GlanceLeaderboardsSlice } from "../app/modules/CompanyLeaderboard/glance/Pages/_redux/Slice";

import { IGameListSlice } from "../app/modules/InstallableGame/GameList/_redux/GameListSlice";
import { ITournamentListSlice } from "../app/modules/InstallableGame/Tournaments/_redux/Slice";
import { IUserListSlice } from "../app/modules/InstallableGame/UserList/_redux/Slice";
import { Slice as liveStreamingSlice } from "../app/modules/LiveStreaming/_redux/Slice";
import { tournamentsSlice } from "../app/modules/Tournaments/_redux/Slice";
import { UsersReportSlice } from "../app/modules/Reports/UsersReport/_redux/UsersReportSlice";
// import { MarketingReportSlice } from "../app/modules/Reports/MarketingReport/_redux/UsersReportSlice";
import { userProfileInvoiceTabSlice } from "../app/modules/UserProfileNew/InvoiceTab/_redux/Slice";
import { HowToJoinSlice } from "../app/modules/CompanyCms/vi/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceD11 } from "../app/modules/CompanyCms/d11/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceGJ } from "../app/modules/CompanyCms/Gamerji/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceGP } from "../app/modules/CompanyCms/goPlay/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceAM } from "../app/modules/CompanyCms/ampere/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceOP } from "../app/modules/CompanyCms/OP/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceGLO } from "../app/modules/CompanyCms/GLO/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceTLB } from "../app/modules/CompanyCms/TLB/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceJZ } from "../app/modules/CompanyCms/JZ/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceETL } from "../app/modules/CompanyCms/ETL/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceME } from "../app/modules/CompanyCms/me/HowToJoin/_redux/HowToJoinSlice";
import { HowToJoinSliceBS } from "../app/modules/CompanyCms/bs/HowToJoin/_redux/HowToJoinSlice";
import { FileUploadSliceME } from "../app/modules/CompanyCms/me/LanguageFileUpload/_redux/Slice";
import { FileUploadSliceBS } from "../app/modules/CompanyCms/bs/LanguageFileUpload/_redux/Slice";
import { FileUploadSliceGJ } from "../app/modules/CompanyCms/Gamerji/LanguageFileUpload/_redux/Slice";
import { FileUploadSliceD11 } from "../app/modules/CompanyCms/d11/LanguageFileUpload/_redux/Slice";
import { HowToJoinSliceonMob } from "../app/modules/CompanyCms/onMob/HowToJoin/_redux/HowToJoinSlice";
import { packageListSlice } from "../app/modules/Subscription/_redux/Slice";
import { Slice as stateSlice } from "../app/modules/State/_redux/Slice";
import { Slice as citiesSlice } from "../app/modules/City/_redux/Slice";
import { Slice as videoSlice } from "../app/modules/Videos/_redux/Slice";
// import { NewinitialSettings } from "../app/modules/Subscription/Subscriptionsetting/_redux/Slice";
import { Slice as optionSlice } from "../app/modules/GeneralSettings/_redux/Slice";
import { UserLoginReportSlice } from "../app/modules/Reports/UserLoginReport/_redux/UserLoginReportSlice";
import { UserJoinTournamentReportSlice } from "../app/modules/Reports/UserJoinTournamentReport/_redux/UserJoinTournamentReportSlice";
// import { HowToJoinSliceTLB } from "../app/modules/CompanyCms/TLB/HowToJoin/_redux/HowToJoinSlice";

import { WonTheLeagueReportSlice } from "../app/modules/Reports/WonTheLeagueReport/GJ/_redux/WonTheLeagueReportSlice";
import { RefundReportSlice } from "../app/modules/Reports/RefundReport/GJ/_redux/RefundReportSlice";

import { NewAddContestSlice } from "../app/modules/v2/Contests/AddContest/_redux/Slice";
import { transactionListJazz } from "../app/modules/JazzTransactions/_redux/Slice";
import { transactionListEasyPaisa } from "../app/modules/EasyPaisaTransactions/_redux/Slice";
import { transactionListGoPlay } from "../app/modules/GoPlayTransactions/_redux/Slice";
import { transactionListAmpere } from "../app/modules/AmpereTransactions/_redux/Slice";


import { transactionListMobily } from "../app/modules/MobilyTransactions/_redux/Slice";
import { transactionListGamerji } from "../app/modules/GamerjiTransactions/_redux/Slice";
import { transactionListXiaomi } from "../app/modules/FunngroTransactions/_redux/Slice";
import { transactionListSafaricom } from "../app/modules/SafaricomReport/_redux/Slice";
import { transactionListTalabat } from "../app/modules/TalabatReport/_redux/Slice";
import { transactionListBisb } from "../app/modules/BisbReport/_redux/Slice";
import { transactionListIndgg } from "../app/modules/IndggReport/_redux/Slice";
import { transactionListOoredoo } from "../app/modules/OoredooReport/_redux/Slice";
import { transactionListGlo } from "../app/modules/GloReport/_redux/Slice";
import { transactionListD11 } from "../app/modules/D11Transactions/_redux/Slice";
import { transactionListVi } from "../app/modules/ViTransactions/_redux/Slice";

import { EPContestsReportSlice } from "../app/modules/EPContestReport/_redux/ContestsReportSlice";
import { GPContestsReportSlice } from "../app/modules/GPContestReport/_redux/ContestsReportSlice";
import { AMContestsReportSlice } from "../app/modules/AMContestReport/_redux/ContestsReportSlice";
import { VINewContestsReportSlice } from "../app/modules/ViTransactionsNew/_redux/Slice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  videos: videoSlice.reducer,
  userProfileCrm: userProfileCrm.reducer,
  userProfileRewardTransaction: userProfileRewardTransaction.reducer,
  upload: uploadSlice.reducer,
  currency: CurrencySlice.reducer,
  banners: bannersSlice.reducer,
  states: stateSlice.reducer,
  cities: citiesSlice.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  staffUsers: staffUsersSlice.reducer,
  affiliateprogramNew: affiliateprogramnewSlice.reducer,
  userPlayedGameReport: userPlayedGameReportSlice.reducer,
  userCoinConsumerReport: userCoinConsumerReportSlice.reducer,
  HackerSlice: HackerSlice.reducer,
  blogs: blogSlice.reducer,
  apkScreenList: apkSlice.reducer,
  H5categories: H5categoriesSlice.reducer,
  H5Games: H5GamesSlice.reducer,
  Levels: LevelsSlice.reducer,
  liveStreamings: liveStreamingSlice.reducer,
  notifications: notificationsSlice.reducer,
  dashboard: UsersSlice.reducer,
  analytics: AnalyticsSlice.reducer,
  videoRequests: videoRequestSlice.reducer,
  components: ComponentsSlice.reducer,
  sponsors: sponsorSlice.reducer,
  sponsorAds: sponsorAdSlice.reducer,
  // Reports Starts
  retentionReport: RetentionReportSlice.reducer,
  buyCoinsReport: BuyCoinsReportSlice.reducer,
  buyBundlesReport: BuyBundlesReportSlice.reducer,
  cashfreeTransactionsReport: CashfreeTransactionsReportSlice.reducer,
  usersLedgerReport: UsersLedgerReportSlice.reducer,
  usersLedgerReport1: UsersLedgerReportSlice1.reducer,
  usersLedgerReportd11: UsersLedgerReportSliced11.reducer, // d11
  usersLedgerReportme: UsersLedgerReportSliceme.reducer, // mobily
  viusersLedgerReport: viUsersLedgerReportSlice.reducer,
  businessDailyReport: BusinessDailyReportSlice.reducer,
  requestLogReport: RequestLogReportSlice.reducer,
  appFlyersReport: AppFlyerSlice.reducer,
  addEventsSlice: AddEventsSlice.reducer,
  appEventsSlice: AppEventsSlice.reducer,
addContests1: AddContestSlice1.reducer,
  
  allTimeRetentionReport: AllTimeRetentionReportSlice.reducer,
  contestsReportt: ContestsReportSlicee.reducer,
  userDailyGame: UserDailyGameSlice.reducer,
  userLeaderboardReport: UserLeaderboardReportSlice.reducer,
  userGameLeaderboardReport: UserGameLeaderboardReportSlice.reducer,
  retention: RetentionSlice.reducer,
  gst: GstSlice.reducer,
  crm: CrmSlice.reducer,
  loginlogs: LoginLogsReportSlice.reducer,
  downloadreport: DownloadReportSlice.reducer,
  logdownloadreport: LogDownloadReportSlice.reducer,
  withdrawalsRequestReport: WithdrawalsRequestReportSlice.reducer,
  walletSummaryReport: WalletSummaryReportSlice.reducer,
  // Reports Ends
  couponCategories: couponCategorySlice.reducer,
  coupons: couponSlice.reducer,
  // Withdrawals Request Starts
  withdrawalsRequest: WithdrawalsRequestSlice.reducer,
  // Withdrawals Request Ends
  pointCategories: pointCategorySlice.reducer,
  // User Profile New Starts
  userProfileNew: UserProfileNewSlice.reducer,
  overviewTabUserProfileNew: OverviewTabUserProfileNewSlice.reducer,
  walletTabUserProfileNew: WalletTabUserProfileNewSlice.reducer,
  gamesTabUserProfileNew: GamesTabUserProfileNewSlice.reducer,
  logsTabUserProfile: LogsTabUserProfileNewSlice.reducer,
  // User Profile New Ends
  levels: levelSlice.reducer,
  //VoucherNewSlice
  voucherNew: VoucherNewSlice.reducer,
  // Contests Starts
  contestList: ContestListSlice.reducer,
  contestCategories: ContestCategoriesSlice.reducer,
  addContestCategory: AddContestCategorySlice.reducer,
  contestUserList: ContestUserListSlice.reducer,
  contestTransactions: ContestTransactionsSlice.reducer,
  contestAssignList: ContestAssignListSlice.reducer,
  assignContest: ContestAssignListSlice.reducer,
  auditContest: AuditContestListSlice.reducer,
  contestAssignShortLink: ContestAssignShortLinkListSlice.reducer,
  contestsReport: ContestsReportSlice.reducer,
  newcontestsReportList: NewContestsReportSlice.reducer,
  ViContestsReportSlice: ViContestsReportSlice.reducer,
  R11ContestsReportSlice: R11ContestsReportSlice.reducer,

  countries: countrySlice.reducer,
  frontendCountry: FrontendCountrySlice.reducer,
  // slicerewards: Slicerewards.reducer,
  // Contests Ends
  points: pointSlice.reducer,
  // New Contest Module
  newContestList: NewContestListSlice.reducer,
  newCasualcontestList: NewCasualcontestSlice.reducer,
  oreedooContestList: OreedooContestListSlice.reducer,
  colleges: collegeSlice.reducer,
  contestsType: NewContestTypeSlice.reducer,
  R11ContestsReportSlice: R11ContestsReportSlice.reducer,
  addContestsType: AddContestTypeSlice.reducer,
  contestsShortLink: NewContestShortLinkSlice.reducer,
  contestsEventList: NewContestEventListSlice.reducer,
  AddContestNewAssign: AddContestAssignSlice.reducer,
  addContestsUser: AddContestUserSlice.reducer,
  addContestUserForm: AddContestUserFormSlice.reducer,
  contestsAssign: ContestAssignSlice.reducer,
  addContestsAssign: AddContestAssignSlice.reducer,
  contestsReAssign: ContestReAssignSlice.reducer,
  auditContests: AuditContestSlice.reducer,
  addContests: AddContestSlice.reducer,
  addContests1: AddContestSlice1.reducer,
  contestsBoard: ContestBoardSlice.reducer,

  CoinPackages: CoinPackageSlice.reducer,
  AddCoinForm: AddCoinFormSlice.reducer,

  tournamentTransaction: TournamentTransactionSlice.reducer,
  languages: languageSlice.reducer,
  AddCompany: CompanySlice.reducer,
  AddCompanyForm: AddCompanyFormSlice.reducer,
  tournamentsSlice: Slice.reducer,
  // Banner's Starts

  // Banner's Ends

  // Roles Starts
  newRole: NewRoleSlice.reducer,
  // Roles Ends

  // Audit Starts
  auditReasons: AuditReasonsSlice.reducer,
  // Audit Ends

  // Rewards Starts
  rewardsTransaction: RewardsTransactionSlice.reducer,
  rewardsCategories: RewardsCategoriesSlice.reducer,
  rewardsProductsList: RewardsProductsListSlice.reducer,
  rewardsLiveProducts: RewardsLiveProductsSlice.reducer,
  // Rewards Ends

  // Youtubes Starts
  channelRequests: ChannelRequestsSlice.reducer,
  // Youtubes Ends

  // HTML5Games Starts
  html5GamesCategories: HTML5GamesCategoriesSlice.reducer,
  html5GamesList: HTML5GamesListSlice.reducer,
  hTML5GamesJoiningSlice: HTML5GamesJoiningListSlice.reducer,
  hTML5GamesWiseJoiningSlice: HTML5GameWiseJoiningListSlice.reducer,
  // HTML5Games Ends

  // App Flyer Token
  appFlyerTokenList: AppFlyerTokenSlice.reducer,
  addAppFlyerToken: AddAppFlyerTokenSlice.reducer,
  // App Flyer Token Ends

  searchList: SelectComponentsSlice.reducer,
  options: optionSlice.reducer,
  //Game
  gameList: GameListSlice.reducer,
  externalGameList: ExternalGameListSlice.reducer,
  addExternalGame: AddExternalGameSlice.reducer,
  addGame: AddGameSlice.reducer,
  gameSetting: GameSettings.reducer,
  //Game Ends
  // addtournaments: Slice.reducer,
  //Game Type
  gameType: GameTypeListSlice.reducer,
  addGameType: AddGameTypeSlice.reducer,
  //Game Type Ends
  avatarCategories: avatarCategorySlice.reducer,
  avatars: avatarSlice.reducer,
  dashboard: UsersSlice.reducer,
  reports: reportsSlice.reducer,
  youtube: Slice.reducer,
  clashroyale: ClashRoyaleSlice.reducer,

  // Contests Starts
  tournamentsSlice: tournamentsSlice.reducer,
  // Contests Ends

  //scrim
  newScrimList: NewScrimSlice.reducer,
  newScrimReportList: NewScrimReportSlice.reducer,
  newUserPurchedList: NewUserPurchedList.reducer,
  newPaidList: NewPaidList.reducer,
  usersRedeemrewards: UsersRedeemrewards.reducer,
  newScrimTransactionReportList: NewScrimTransactionReportSlice.reducer,
  scrimListt: ScrimListtSlice.reducer,
  gamescrimSetting: GameScrimSetting.reducer,
  scrimTabUserProfile: ScrimsTabUserProfileNewSlice.reducer,
  newGamewisereportSlice: NewGamewisereportSlice.reducer,
  rewards: rewardSlice.reducer,
  dailyLoginRewards: dailyLoginRewards.reducer,
  rewardss: rewardSlicee.reducer,

  // rewardss: rewardSlicee.reducer,
  newCompanyreportSlice: NewCompanyreportSlice.reducer,
  newAdsreportSlice: NewAdsreportSlice.reducer,
  newAdspositionSlice: NewAdspositionSlice.reducer,

  //adssss detailss pagw
  newAdscompanylistSlice: NewAdscompanylistSlice.reducer,
  newinitialSettings: NewinitialSettings.reducer,
  //scrim

  //Vi FAQ
  FAQ: FAQSlice.reducer,
  FaqByGame: FaqByGameSlice.reducer,
  popupNotifications: popupNotificationsSlice.reducer,
  transactionList: TransactionSlice.reducer,
  transactionListFinshell: transactionListFinshell.reducer,
  
  notificationList: NotificationSlice.reducer,
  leaderboards: leaderboardSlice.reducer,
  glanceLeaderboards: GlanceLeaderboardsSlice.reducer,

  // vi Banner
  // viBanner:viBannerSlice.reducer,
  //GAMERJI
  gjBanners: gjBanners.reducer,

  // goplay banners
  gpBanners: gpBanners.reducer,

  // ampere banners
  amBanners: amBanners.reducer,

  coinStores: coinStoreSlice.reducer,
  // downloadAdscompany: DownloadAdscompany.reducer,

  viBanners: viBanners.reducer,
  viPages: viPages.reducer,
  glancePages: glancePages.reducer,

  //TimeSLot
  addTimeSlote: AddTimeSlotSlice.reducer,
  addTournament: Slice.reducer,
  //Customer Care
  CustomerCare: CustomerCareSlice.reducer,
  timeSlot: TimeSlotSlice.reducer,
  bannerlog: BannerLogSlice.reducer,
  //instabaleGame
  insatbleGameList: IGameListSlice.reducer,
  insatbleTournament: ITournamentListSlice.reducer,
  insatbleUser: IUserListSlice.reducer,
  userReport: UsersReportSlice.reducer,
  marketingReport: MarketingReportSlice.reducer,
  userProfileInvoice: userProfileInvoiceTabSlice.reducer,
  marketingReport: MarketingReportSlice.reducer,
  howToJoin: HowToJoinSlice.reducer,
  // languagefileupload: HowToJoinSlice.reducer,
  howToJoinD11: HowToJoinSliceD11.reducer,
  howToJoinGJ: HowToJoinSliceGJ.reducer,
  howToJoinGP: HowToJoinSliceGP.reducer,
  howToJoinAM: HowToJoinSliceAM.reducer,
  howToJoinOP: HowToJoinSliceOP.reducer,
  howToJoinGLO: HowToJoinSliceGLO.reducer,
  howToJoinTLB: HowToJoinSliceTLB.reducer,
  howToJoinJZ: HowToJoinSliceJZ.reducer,
  howToJoinETL: HowToJoinSliceETL.reducer,
  howToJoinME: HowToJoinSliceME.reducer,
  howToJoinBS: HowToJoinSliceBS.reducer,
  fileUploadME: FileUploadSliceME.reducer,
  fileUploadBS: FileUploadSliceBS.reducer,
  fileUploadGJ: FileUploadSliceGJ.reducer,
  fileUploadD11: FileUploadSliceD11.reducer,
  howToJoinonMob: HowToJoinSliceonMob.reducer,
  packageListSlice: packageListSlice.reducer,
  userLoginReport: UserLoginReportSlice.reducer,
  userJoinTournamentReport: UserJoinTournamentReportSlice.reducer,
  wonTheLeagueReport: WonTheLeagueReportSlice.reducer,
  refundReport: RefundReportSlice.reducer,
  newAddContests: NewAddContestSlice.reducer,

  transactionListEasyPaisa: transactionListEasyPaisa.reducer,
  transactionListGoPlay: transactionListGoPlay.reducer,
  transactionListAmpere: transactionListAmpere.reducer,
  transactionListMobily: transactionListMobily.reducer,
  transactionListGamerji: transactionListGamerji.reducer,
  transactionListXiaomi: transactionListXiaomi.reducer,
  transactionListSafaricom: transactionListSafaricom.reducer,
  transactionListTalabat: transactionListTalabat.reducer,
  transactionListBisb: transactionListBisb.reducer,
  transactionListIndgg: transactionListIndgg.reducer,
  transactionListOoredoo: transactionListOoredoo.reducer,
  transactionListGlo: transactionListGlo.reducer,
  transactionListD11: transactionListD11.reducer,
  transactionListJazz: transactionListJazz.reducer,
  transactionListVi: transactionListVi.reducer,
  EPContestsReportList: EPContestsReportSlice.reducer,
  GPContestsReportList: GPContestsReportSlice.reducer,
  AMContestsReportList: AMContestsReportSlice.reducer,
  VINewContestsReportList: VINewContestsReportSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
